<svg width="100%" height="100%" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11 4.5C7.13401 4.5 4 7.63401 4 11.5C4 15.366 7.13401 18.5 11 18.5C12.8001 18.5 14.4415 17.8205 15.6817 16.7041L16.2041 16.1817C17.3205 14.9415 18 13.3001 18 11.5C18 7.63401 14.866 4.5 11 4.5ZM18.0319 17.1177C19.2635 15.578 20 13.625 20 11.5C20 6.52944 15.9706 2.5 11 2.5C6.02944 2.5 2 6.52944 2 11.5C2 16.4706 6.02944 20.5 11 20.5C13.125 20.5 15.078 19.7635 16.6177 18.5319L21 22.9142L22.4142 21.5L18.0319 17.1177Z"
    fill="black"
  />
</svg>
